module.exports = __webpack_public_path__ + "components/app-promo/static/de/snow-forecast__app-screenshot--3-8d3c16f96cb3b8346123fb025c1a273f.jpg";